export default "__VITE_ASSET__727c60e8__"